/**
 *
 * WidgetDetailsResponse
 *
 */

import React, { Fragment } from "react"
// import PropTypes from 'prop-types';
import { Divider, Spin } from "antd"
import { get } from "lodash"
import "./index.less"

/* eslint-disable react/prefer-stateless-function */
class WidgetDetailsResponse extends React.Component {

  render() {
    const { small } = this.props

    return (
      <div
        className={`measurement-details-response ${
          small ? "measurement-details-response-small" : ""
        }`}
        style={
          this.props.isLoading
            ? {
                display: "grid",
                alignItems: "center",
                margin: "0 auto",
                gridTemplateColumns: "auto",
                justifyContent: "unset",
              }
            : {}
        }>
        {this.props.isLoading ? (
          <div className="loadingSpin">
            <Spin size="large" />
          </div>
        ) : (
          <Fragment>
            <div className="measurement-details-response-item subtitle_section">
              {!small && <div>Total de preguntas</div>}
              <span className="measurement-details-response-item-number">
                {get(this.props.responseTime, "measure.question_count", 0)}
              </span>
              <span>preguntas</span>
            </div>
            <Divider
              type="vertical"
              style={{ height: small ? "50%" : "100%" }}
            />
            <div className="measurement-details-response-item subtitle_section">
              {!small && <div>Total de destinatarios</div>}
              <span className="measurement-details-response-item-number">
                {small
                  ? get(
                      this.props.responseTime,
                      "measure_climate.dimensions",
                      0
                    )
                  : get(this.props.responseTime, "measure.recipients", 0)}
              </span>
              <span>{small ? "dimensiones" : "destinatarios"}</span>
            </div>
            <Divider
              type="vertical"
              style={{ height: small ? "50%" : "100%" }}
            />
            <div className="measurement-details-response-item subtitle_section">
              {!small && <div>Tiempo esperado de respuesta</div>}
              <span className="measurement-details-response-item-number">
                {small
                  ? get(this.props.responseTime, "measure_climate.divisions", 0)
                  : get(this.props.responseTime, "measure.survey_time", 0) || 0} 
              </span>
              <span>{small ? "divisiones" : "minutos"}</span>
            </div>
          </Fragment>
        )}
      </div>
    )
  }
}

WidgetDetailsResponse.propTypes = {}

export default WidgetDetailsResponse
